export default __webpack_public_path__ + "static/media/frg--sales-display.3f4f2d0d.png";